import type { TableHeadCellProps } from 'src/components/table';

import { Dialog, IconButton, DialogTitle, DialogContent } from '@mui/material';

import { paths } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';
import { TableCustom } from 'src/components/table';

type Props = {
  open: boolean;
  onClose: () => void;
  type: string;
  tableData: any[];
  tableConfig: any;
  isLoader: boolean;
  onRecordSelect: (row: any) => void;
  t: (key: string) => string;
};

export function RecordSelectionDialog({
  open,
  onClose,
  type,
  tableData,
  tableConfig,
  isLoader,
  onRecordSelect,
  t,
}: Props) {
  const CONTACT_TABLE_HEAD: TableHeadCellProps[] = [
    { id: 'firstName', label: t('FIRST_NAME'), width: 200, filterable: true, isDisable: true },
    { id: 'lastName', label: t('LAST_NAME'), width: 200, filterable: true },
    { id: 'phone', label: t('PHONE_NUM'), width: 200 },
    { id: 'email', label: t('EMAIL'), width: 200 },
  ];

  const CHANNEL_TABLE_HEAD: TableHeadCellProps[] = [
    { id: 'channelName', label: t('CHANNEL_NAME'), width: 600, filterable: true, isDisable: true },
    { id: 'channelConfig', label: t('CHANNEL_CONFIG'), width: 300 },
  ];

  const ACCOUNT_TABLE_HEAD: TableHeadCellProps[] = [
    { id: 'name', label: t('ACCOUNT_NAME'), width: 200, filterable: true, isDisable: true },
    { id: 'email', label: t('EMAIL'), width: 200 },
    { id: 'phone', label: t('CONTACT_NUM'), width: 200 },
    { id: 'crNumber', label: t('CR_NUMBER'), width: 100 },
    { id: 'city', label: t('CITY'), width: 100 },
    { id: 'country', label: t('COUNTRY'), width: 100 },
  ];

  const USER_TABLE_HEAD: TableHeadCellProps[] = [
    { id: 'firstName', label: t('FIRST_NAME'), width: 200, isDisable: true },
    { id: 'lastName', label: t('LAST_NAME'), width: 200 },
    { id: 'email', label: t('EMAIL'), width: 180 },
    { id: 'role', label: t('ROLE'), width: 100 },
    { id: 'joinedDate', label: t('JOINED_DATE'), width: 100 },
    { id: 'status', label: t('STATUS'), width: 100 },
  ];

  const TEAM_TABLE_HEAD: TableHeadCellProps[] = [
    { id: 'teamName', label: t('TEAM_NAME'), width: 300, isDisable: true },
    { id: 'noOfUsers', label: t('NO_OF_USERS'), width: 100 },
    { id: 'createdDate', label: t('CREATED_DATE'), width: 100 },
    { id: 'status', label: t('STATUS'), width: 100 },
  ];

  const CONVERSATION_TABLE_HEAD: TableHeadCellProps[] = [
    { id: 'displayName', label: t('DISPLAY_NAME'), width: 300, filterable: true, isDisable: true },
    { id: 'lastMessage', label: t('LAST_MESSAGE'), width: 400 },
    { id: 'status', label: t('STATUS'), width: 100 },
    { id: 'createdAt', label: t('CREATED_AT'), width: 200 },
  ];

  const tableHeads: Record<string, TableHeadCellProps[]> = {
    Contact: CONTACT_TABLE_HEAD,
    Channel: CHANNEL_TABLE_HEAD,
    Account: ACCOUNT_TABLE_HEAD,
    User: USER_TABLE_HEAD,
    Team: TEAM_TABLE_HEAD,
    Conversation: CONVERSATION_TABLE_HEAD,
  };

  const editHref = (id: string): string => paths.contact.details(id);

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          p: 3,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span>{t(`SELECT_${type.toUpperCase()}`)}</span>
        <IconButton onClick={onClose}>
          <Iconify icon="eva:close-fill" width={24} />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ pt: 1, pb: 1 }}>
        <TableCustom
          columns={tableHeads[type] || []}
          data={tableData}
          {...tableConfig}
          editHref={editHref}
          isCheckboxVisible={false}
          rowHeight
          moduleName={type}
          isShowCreateBtn={false}
          selectRowPremission={false}
          isSelectRowPremission={false}
          isSelectRecordDialog
          setRecordInputHandler={onRecordSelect}
          isSearchFullWidth
        />
      </DialogContent>
    </Dialog>
  );
}